import axios from "axios";
import { server } from "../../server";

// load delivery user
export const loadDeliveryUser = () => async (dispatch) => {
  try {
    dispatch({
      type: "LoadDeliveryUserRequest",
    });
    const { data } = await axios.get(`${server}/deliveryuser/get-delivery-user`, {
      withCredentials: true,
    });
    dispatch({
      type: "LoadDeliveryUserSuccess",
      payload: data.deliveryUser,
    });
  } catch (error) {
    dispatch({
      type: "LoadDeliveryUserFail",
      payload: error?.response?.data?.message,
    });
  }
};

// load seller
// export const loadSeller = () => async (dispatch) => {
//   try {
//     dispatch({
//       type: "LoadSellerRequest",
//     });
//     const { data } = await axios.get(`${server}/shop/getSeller`, {
//       withCredentials: true,
//     });
//     dispatch({
//       type: "LoadSellerSuccess",
//       payload: data.seller,
//     });
//   } catch (error) {
//     dispatch({
//       type: "LoadSellerFail",
//       payload: error.response.data.message,
//     });
//   }
// };

// // Delivery user update information
// export const updateDeliveryUserInformation =
//   (name, email, phoneNumber, password) => async (dispatch) => {
//     try {
//       dispatch({
//         type: "updateDeliveryUserInfoRequest",
//       });

//       const { data } = await axios.put(
//         `${server}/user/update-user-info`,
//         {
//           email,
//           password,
//           phoneNumber,
//           name,
//         },
//         {
//           withCredentials: true,
//           headers: {
//             "Access-Control-Allow-Credentials": true,
//           },
//         }
//       );

//       dispatch({
//         type: "updateDeliveryUserInfoSuccess",
//         payload: data.user,
//       });
//     } catch (error) {
//       dispatch({
//         type: "updateDeliveryUserInfoFailed",
//         payload: error.response.data.message,
//       });
//     }
//   };

// // update Delivery user address
// export const updatDeliveryUserAddress =
//   (country, city, address1, address2, zipCode, addressType) =>
//   async (dispatch) => {
//     try {
//       dispatch({
//         type: "updateDeliveryUserAddressRequest",
//       });

//       const { data } = await axios.put(
//         `${server}/user/update-user-addresses`,
//         {
//           country,
//           city,
//           address1,
//           address2,
//           zipCode,
//           addressType,
//         },
//         { withCredentials: true }
//       );

//       dispatch({
//         type: "updateDeliveryUserAddressSuccess",
//         payload: {
//           successMessage: "Delivery User address updated succesfully!",
//           deliveryuser: data.deliveryuser,
//         },
//       });
//     } catch (error) {
//       dispatch({
//         type: "updateDeliveryUserAddressFailed",
//         payload: error.response.data.message,
//       });
//     }
//   };

// // delete delivery user address
// export const deleteDeliveryUserAddress = (id) => async (dispatch) => {
//   try {
//     dispatch({
//       type: "deleteDeliveryUserAddressRequest",
//     });

//     const { data } = await axios.delete(
//       `${server}/user/delete-user-address/${id}`,
//       { withCredentials: true }
//     );

//     dispatch({
//       type: "deleteDeliveryUserAddressSuccess",
//       payload: {
//         successMessage: "Delivery user deleted successfully!",
//         deliveryUser: data.deliveryUser,
//       },
//     });
//   } catch (error) {
//     dispatch({
//       type: "deleteDeliveryUserAddressFailed",
//       payload: error.response.data.message,
//     });
//   }
// };

// // get all Delivery users --- admin
// export const getAllDeliveryUsers = () => async (dispatch) => {
//   try {
//     dispatch({
//       type: "getAllDeliveryUsersRequest",
//     });

//     const { data } = await axios.get(`${server}/user/admin-all-users`, {
//       withCredentials: true,
//     });

//     dispatch({
//       type: "getAllDeliveryUsersSuccess",
//       payload: data.deliveryUsers,
//     });
//   } catch (error) {
//     dispatch({
//       type: "getAllDeliveryUsersFailed",
//       payload: error.response.data.message,
//     });
//   }
// };
